/* ---------------------------------------------------------------------------
   Product add-ons  ·  Rich Petals
   Adds the selected add-on products to the cart in the SAME request as the
   main product, by rewriting the theme's /cart/add request body.
   No app, no theme-JS edits.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.__richPetalsAddons) return;
  window.__richPetalsAddons = true;

  var SELECTOR = '[data-product-addons]';
  var lastForm = null;

  /* Remove add-ons from the cart when their parent product is removed.
     Set to false to let orphaned add-ons stay in the cart. */
  var REMOVE_ORPHANS = true;

  /* ------------------------------ money ---------------------------------- */

  function formatMoney(cents, format) {
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '{{ amount }}';

    function num(number, precision, thousands, decimal) {
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    switch ((format.match(placeholder) || [])[1]) {
      case 'amount': value = num(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ','); break;
      default: value = num(cents, 2, ',', '.');
    }
    return format.replace(placeholder, value);
  }

  /* ---------------------------- selection -------------------------------- */

  /* The bouquet's own title, read from Shopify's page metadata — immune to any
     Liquid scoping surprise in the block. Falls back to the data attribute. */
  function pageProductTitle() {
    try {
      var meta = window.ShopifyAnalytics
        && window.ShopifyAnalytics.meta
        && window.ShopifyAnalytics.meta.product;
      if (!meta || !meta.variants || !meta.variants.length) return '';
      var v = meta.variants[0];
      var name = v.name || '';
      var pub = v.public_title;
      if (pub && name.slice(-(pub.length + 3)) === ' - ' + pub) {
        return name.slice(0, -(pub.length + 3));
      }
      return name;
    } catch (e) {
      return '';
    }
  }

  function cardsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-addon-card]'));
  }

  function selectedIn(root) {
    var out = [];
    cardsOf(root).forEach(function (card) {
      var input = card.querySelector('.addon-card__input');
      if (!input || !input.checked || !input.value) return;
      var qtyInput = card.querySelector('[data-addon-qty]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      out.push({
        id: input.value,
        qty: qty > 0 ? qty : 1,
        price: parseInt(input.getAttribute('data-price') || '0', 10),
        title: card.getAttribute('data-title') || '',
        parent: pageProductTitle() || root.getAttribute('data-parent-title') || '',
        label: root.getAttribute('data-property-label') || ''
      });
    });
    return out;
  }

  /* Decide which add-on blocks belong to the form being submitted. */
  function activeRoots(form) {
    var all = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    if (!all.length) return [];
    if (!form) return all;

    var section = form.closest('.shopify-section');
    if (section) {
      var inSection = Array.prototype.slice.call(section.querySelectorAll(SELECTOR));
      if (inSection.length) return inSection;
    }

    var pid = form.querySelector('[name="product-id"]');
    if (pid && pid.value) {
      var matched = all.filter(function (r) { return r.getAttribute('data-product-id') === pid.value; });
      if (matched.length) return matched;
      return []; // a different product's form (quick add) — never attach add-ons
    }
    return all;
  }

  function collect(form) {
    var out = [];
    activeRoots(form).forEach(function (root) {
      out = out.concat(selectedIn(root));
    });
    return out;
  }

  /* --------------------------- body rewriting ---------------------------- */

  function appendAddons(fd, addons, startIndex, parentId) {
    addons.forEach(function (a, i) {
      var n = startIndex + i;
      fd.append('items[' + n + '][id]', a.id);
      fd.append('items[' + n + '][quantity]', a.qty);
      fd.append('items[' + n + '][properties][_addon]', 'true');
      if (parentId) {
        fd.append('items[' + n + '][properties][_addon_parent]', parentId);
      }
      if (a.label && a.parent) {
        fd.append('items[' + n + '][properties][' + a.label + ']', a.parent);
      }
    });
  }

  function mergeFormData(fd, addons) {
    var id = fd.get('id');
    if (!id) return null;

    var out = new FormData();
    out.append('items[0][id]', id);
    out.append('items[0][quantity]', fd.get('quantity') || '1');

    fd.forEach(function (value, key) {
      if (key === 'id' || key === 'quantity' || key === 'form_type' || key === 'utf8' || key === 'product-id') return;
      var prop = key.match(/^properties\[(.+)\]$/);
      if (prop) { out.append('items[0][properties][' + prop[1] + ']', value); return; }
      if (key === 'selling_plan') { out.append('items[0][selling_plan]', value); return; }
      out.append(key, value); // keeps `sections` / `sections_url` so the drawer still renders
    });

    appendAddons(out, addons, 1, id);
    return out;
  }

  function mergeJson(body, addons) {
    var data;
    try { data = JSON.parse(body); } catch (e) { return null; }

    var items = Array.isArray(data.items) ? data.items.slice() : null;
    if (!items) {
      if (!data.id) return null;
      var first = { id: data.id, quantity: data.quantity || 1 };
      if (data.properties) first.properties = data.properties;
      if (data.selling_plan) first.selling_plan = data.selling_plan;
      items = [first];
    }

    var parentId = items[0] && items[0].id;
    addons.forEach(function (a) {
      var props = { _addon: 'true' };
      if (parentId) props._addon_parent = String(parentId);
      if (a.label && a.parent) props[a.label] = a.parent;
      items.push({ id: Number(a.id), quantity: a.qty, properties: props });
    });

    var out = { items: items };
    if (data.sections) out.sections = data.sections;
    if (data.sections_url) out.sections_url = data.sections_url;
    return JSON.stringify(out);
  }

  /* ------------------------ orphaned add-on cleanup ----------------------- */

  var cleaning = false;

  /* An add-on whose parent product is no longer in the cart is meaningless —
     the delivery date, the recipient, the whole order context lives on the
     parent line. Remove it. */
  function cleanOrphanAddons() {
    if (!REMOVE_ORPHANS || cleaning) return Promise.resolve(false);
    cleaning = true;

    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return false;

        var parentsPresent = {};
        cart.items.forEach(function (item) {
          var props = item.properties || {};
          if (!props._addon_parent) parentsPresent[String(item.variant_id)] = true;
        });

        var updates = {};
        var orphans = 0;
        cart.items.forEach(function (item) {
          var props = item.properties || {};
          var parent = props._addon_parent;
          if (parent && !parentsPresent[String(parent)]) {
            updates[item.key] = 0;
            orphans++;
          }
        });

        if (!orphans) return false;

        return nativeFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { return true; });
      })
      .catch(function (err) {
        console.warn('[product-addons] orphan cleanup', err);
        return false;
      })
      .then(function (changed) {
        cleaning = false;
        return changed;
      });
  }

  function cleanThenRefresh() {
    cleanOrphanAddons().then(function (changed) {
      if (!changed) return;
      document.dispatchEvent(new CustomEvent('addons:orphans-removed'));
      window.location.reload();
    });
  }

  /* ------------------------- intercept the request ----------------------- */

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[action*="/cart/add"]') : null;
    if (form) lastForm = form;
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('[name="add"], form[action*="/cart/add"] [type="submit"]');
    if (btn) {
      var form = btn.closest('form[action*="/cart/add"]') || btn.form;
      if (form) lastForm = form;
    }
  }, true);

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && init.body) {
        var addons = collect(lastForm);
        if (addons.length) {
          var merged = null;
          if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
            merged = mergeFormData(init.body, addons);
          } else if (typeof init.body === 'string') {
            merged = mergeJson(init.body, addons);
          }
          if (merged) {
            init = Object.assign({}, init, { body: merged });
            document.dispatchEvent(new CustomEvent('addons:attached', { detail: { addons: addons } }));
          }
        }
      }
    } catch (err) {
      console.warn('[product-addons]', err);
    }

    var request = nativeFetch.apply(this, arguments.length > 1 ? [input, init] : [input]);

    /* After the cart is changed anywhere on the site, sweep up add-ons whose
       parent product has just been removed. */
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      if (REMOVE_ORPHANS && !cleaning && /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(u)) {
        request.then(function () { cleanThenRefresh(); }).catch(function () {});
      }
    } catch (e) { /* no-op */ }

    return request;
  };

  /* --------- fallback for themes that post the form natively -------------- */

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[action*="/cart/add"]') : null;
    if (!form || form.dataset.addonsDone) return;

    var roots = activeRoots(form);
    var native = roots.some(function (r) { return r.getAttribute('data-cart-mode') === 'native'; });
    if (!native) return;

    var addons = collect(form);
    if (!addons.length) return;

    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var fd = new FormData();
    appendAddons(fd, addons, 0, idInput ? idInput.value : null);

    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .catch(function (err) { console.warn('[product-addons]', err); })
      .then(function () {
        form.dataset.addonsDone = '1';
        form.submit();
      });
  }, false);

  /* ------------------------------- UI ------------------------------------ */

  function refresh(root) {
    var total = 0;
    var format = root.getAttribute('data-money-format') || '{{ amount }}';

    cardsOf(root).forEach(function (card) {
      var input = card.querySelector('.addon-card__input');
      if (!input) return;
      var qtyWrap = card.querySelector('[data-addon-qty-wrap]');
      var qtyInput = card.querySelector('[data-addon-qty]');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      card.classList.toggle('is-selected', input.checked);
      if (qtyWrap) qtyWrap.hidden = !input.checked;
      if (input.checked && input.value) {
        total += (parseInt(input.getAttribute('data-price') || '0', 10)) * qty;
      }
    });

    var totalEl = root.querySelector('[data-addons-total]');
    if (totalEl) {
      if (total > 0) {
        totalEl.hidden = false;
        totalEl.textContent = (totalEl.getAttribute('data-label') || 'Add-ons') + ': ' + formatMoney(total, format);
      } else {
        totalEl.hidden = true;
      }
    }
  }

  function initShowMore(root) {
    var limit = parseInt(root.getAttribute('data-initial-count') || '0', 10);
    var btn = root.querySelector('[data-addons-more]');
    if (!btn || !limit) return;

    var cards = cardsOf(root);
    if (cards.length <= limit) return;

    var expanded = false;
    var label = btn.querySelector('[data-more-text]');
    var moreText = btn.getAttribute('data-more') || 'Show more';
    var lessText = btn.getAttribute('data-less') || 'Show less';

    function apply() {
      cards.forEach(function (card, i) {
        card.classList.toggle('is-hidden', !expanded && i >= limit);
      });
      if (label) label.textContent = expanded ? lessText : moreText;
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    btn.hidden = false;
    apply();

    btn.addEventListener('click', function () {
      expanded = !expanded;
      apply();
    });
  }

  function init(root) {
    if (root.dataset.addonsReady) return;
    root.dataset.addonsReady = '1';

    root.addEventListener('change', function () { refresh(root); });

    root.addEventListener('click', function (e) {
      var step = e.target.closest ? e.target.closest('[data-addon-step]') : null;
      if (!step) return;
      e.preventDefault();
      e.stopPropagation();
      var card = step.closest('[data-addon-card]');
      var qtyInput = card.querySelector('[data-addon-qty]');
      var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(step.getAttribute('data-addon-step'), 10);
      qtyInput.value = next < 1 ? 1 : next;
      refresh(root);
    });

    initShowMore(root);
    refresh(root);
  }

  function boot() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // the cart page may have been reached after a non-JS removal
  if (REMOVE_ORPHANS && /\/cart(\/|$|\?)/.test(window.location.pathname + window.location.search)) {
    cleanThenRefresh();
  }

  // re-init after theme editor / section re-renders
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
